import { normalize } from 'polished'
import { createGlobalStyle } from 'styled-components'

const Style = createGlobalStyle`
  ${normalize()}

  :root {
    --font-primary: ${({ theme }) => theme.font};
    --color-body: ${({ theme }) => theme.colors.body};
    --color-global: ${({ theme }) => theme.colors.global};
    --color-primary: ${({ theme }) => theme.colors.global};
    --color-primary-dark: ${({ theme }) => theme.colors.primaryDark};
    --color-secondary: ${({ theme }) => theme.colors.primary};
    --color-inverted: #ffffff;
    --color-light: #ffffff;
    --color-muted: #5F6B78;
    --color-green: #0AB500;
    --color-dark: #000329;
    --color-line: #E7EAEE;
    --color-red: #C91900;
    --color-text: #1D2430;
    --color-success: #1E7350;
    --color-success-soft: #EAF6F0;
    --color-warning: #A8540A;
    --color-warning-soft: #FFF4E6;
    --color-neutral: #9AA3AE;
    --radius-card: 14px;
    --radius-control: 12px;
    --size-top-bar: 72px;
  }

  html {
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.45;
    font-family: ${({ theme }) => theme.font};
    color: var(--color-text);
    font-weight: 400;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: var(--color-body);
    margin: 0;
  }

  * {
    box-sizing: border-box;
  }

  button {
    font-family: inherit;
    touch-action: manipulation;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.75rem;
    font-weight: 600;
    line-height: 1.25;
  }

  h1 { font-size: 2rem; }
  h2 { font-size: 1.5rem; }
  h3 { font-size: 1.2rem; }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  img {
    max-width: 100%;
  }
`

export default Style
